import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ACL } from '../../../config/constants';
import { hideSpinner, showSpinner } from "../../../store/actions/loading";
import { Paginator } from '../../layout/Paginator/Paginator';
import { Search } from '../../layout/Table/Search';
import { store } from '../../../store/store';
import { hideNotification } from '../../../store/actions/notification';
import { AutoRefreshTable } from "../../layout/Table/AutoRefreshTable";
import { RowsPerPage } from "../../layout/Table/RowsPerPage";
import { getCouponsApi } from "../../../api/coupons/coupons";
import { TableComponent } from "./editCampaign/table/Table";
import { useParams } from "react-router";
import { Messages } from "../../layout/Messages/Messages";
import { NOTIFICATION_CREATE_COUPON } from "../../../config/notifications";
import { ListToolbar } from '../../layout/Workspace';

function CouponTableComponent(props) {
  const { id } = useParams()
  const { setCouponCreated, couponCreated } = props
  const [ sortDirection, setSortDirection ] = useState( null );
  const [ sortField, setSortField ] = useState( null );
  const [ searchText, setSearchText ] = useState( null );
  const [ coupons, setCoupons ] = useState( null );
  const [ meta, setMeta ] = useState( null );
  const [ rowsPerPage, setRowsPerPage ] = useState( 10 );

  useEffect( () => {
    if (getCoupons && typeof getCoupons === "function" && (couponCreated)) {
      getCoupons(1);
      setCouponCreated(false);
    }
  }, [ couponCreated ] ); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect( () => {
    if (getCoupons && typeof getCoupons === "function") {
      getCoupons(1, sortField, sortDirection, searchText);
    }

    return () => {
      store.dispatch(hideNotification());
    }
  }, [rowsPerPage] ); // eslint-disable-line react-hooks/exhaustive-deps

  /**
   * Get campaigns
   * @param {number} [page]
   * @param {string} [sortField]
   * @param {string} [sortDirection]
   * @param {string} [searchText]
   * @param {boolean} [hideNotification]
   */
  const getCoupons = (page, sortField, sortDirection, searchText, hideNotification = false) => {
    if (! ACL.CLIENT.COUPONS.LIST.hasAccess()) {
      return;
    }

    getCouponsApi({
      pagination: {
        page: page,
        sort_by: sortField,
        sort: sortDirection,
        q: searchText,
        per_page: rowsPerPage,
      },
      hideNotification: hideNotification,
      campaign_id: id,
    }).then(
      response => {
        if (! response || ! response.data) {
          return;
        }

        setCoupons(response.data);

        setMeta(response.meta);
        props.hideSpinner();
      }
    );
  };

  /**
   * Apply sort by appliedSortField
   * @param {string} appliedSortField
   */
  function applySort(appliedSortField) {
    let newSortDirection = "";

    if (sortField) {
      if (sortField === appliedSortField) {
        newSortDirection = sortDirection === "asc" ? "desc" : "asc";
      } else {
        newSortDirection = "asc";
      }
    } else {
      newSortDirection = "asc";
    }

    setSortField( appliedSortField );
    setSortDirection( newSortDirection );

    getCoupons(meta.current_page, appliedSortField, newSortDirection, searchText, true);
  }

  return (
    <div className="campaign-coupons-table-layout">
      <ListToolbar
        className="campaign-coupons-toolbar"
        search={ACL.CLIENT.COUPONS.LIST.hasAccess() && ACL.CLIENT.COUPONS.SEARCH.hasAccess() ? (
          <Search
            id="campaign"
            search={searchText => {
              setSearchText( searchText );
              getCoupons( 1, null, null, searchText, true);
            }}
          />
        ) : null}
        settings={(
          <AutoRefreshTable
            id="coupon"
            getData={ getCoupons }
            sortDirection={ sortDirection }
            sortField={ sortField }
            searchText={ searchText }
          />
        )}
      />
      <div className="campaign-coupons-table-notification">
        <Messages notificationId={ NOTIFICATION_CREATE_COUPON } />
      </div>
      <div className="campaign-coupons-table-table">
        <TableComponent
          shouldRenderFields={ true }
          applySort={ sortField => applySort( sortField ) }
          coupons={ coupons }
          actionCallback={
            useState => {
              if (useState) {
                getCoupons(meta.current_page, sortField, sortDirection, searchText);
              } else {
                getCoupons();
              }
            }
          }
          couponCreated={ couponCreated }
        />
      </div>
      <div className="campaign-coupons-table-pagination">
        <Paginator
          meta={ meta }
          settings={(
            <RowsPerPage
              id="coupon"
              changeRowsPerPage={rowsPerPage => {
                setRowsPerPage(rowsPerPage);
              }}
            />
          )}
          changePage={ page => getCoupons(page, sortField, sortDirection, searchText, true) }
        />
      </div>
    </div>
  )
}

const CouponTable = connect(null, { showSpinner, hideSpinner })(CouponTableComponent);

export { CouponTable, CouponTableComponent };
